<div class="modal-header" appCustomAutofocus>
    <h4>Trips Ready to Complete</h4>
</div>
<div class="modal-body">
    <label>Select a Trip to Complete:</label>
    <div class="row" style="width: 100%">
        <ul style="width: 100%; padding: 10px;">
            <li *ngFor="let data of smDataService.readyToCompleteList" style=" list-style: none;height: 35px;" [ngClass]="{selected: data.selected}">
                <a style="cursor: pointer; vertical-align: -webkit-baseline-middle; margin-left: 15px; " [routerLink]="" (click)="selecteTrip(data)">{{data.TripName}}</a>
            </li>
        </ul>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Close</button>
    <button type="button" class="btn btn-success" (click)="completeClicked()" [disabled]="selectedTrip == null">Complete</button>
</div>